'use strict';

window.console || (window.console = {
	log: function log() {}
});
var SAISON = window.SAISON || null;
var cssua = window.cssua || null;

(function ($) {
	var htmlHasClass = function htmlHasClass(_class) {
		return $('html').hasClass(_class);
	};
	var siteName = '';
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-fixed';
	var slideSpeed = '400';

	SAISON = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test\\.' + siteName + '\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.0\\.|192\\.168\\.11\\.|192\\.168\\.1\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var i, j;
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					for (i = 0; i < args.length; i++) {
						var result = args[i];
						var position = $(result[0]).filter(':first').attr('class').split(' ');

						for (j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(result[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle: function nextToggle() {
			var $switch = $('.js-toggle');

			$switch.on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll: function easeScroll() {
			$('a[rel="scroll"]').on('click', function (event) {
				var speed = 1200;
				if (/#/.test(event.currentTarget.href)) {
					scrollToObject(event.currentTarget.href, speed);
				}
				return false;
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					if (SAISON.va.window.width < SAISON.va.device.sp) {
						pos -= 60;
					} else {
						pos -= 120;
					}
				}

				$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
			}
		},
		easeScrollHash: function easeScrollHash() {
			var hash = location.hash;
			if (hash !== '') {
				$(window).on('load', function () {
					$('html, body').css('display', 'none');

					setTimeout(function () {
						$('html, body').css('display', 'block');

						var _hash = '#' + hash.split('#')[1];
						var pos = $(_hash).offset().top;

						if (SAISON.va.window.width < SAISON.va.device.sp) {
							pos -= 60;
						} else {
							pos -= 120;
						}
						$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
					}, 100);
				});
			}
		},
		pageTop: function pageTop() {
			var $pagetop = $('.footer-pagetop');

			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var $footer = $('.footer');
				// var footerPos = $footer.offset().top + $footer.height();
				var thisScroll = $this.scrollTop();
				// var pagetopPos = $this.height() + $footer.height() + thisScroll;

				if (thisScroll > '150') {
					$pagetop.addClass(v);
				} else {
					$pagetop.removeClass(v);
				}
			});
		},
		headerSwitch: function headerSwitch() {
			var $hamburger = $('.header-hamburger');
			var $nav = $('.header-nav');
			var $overlay = $('.header-overlay');
			var $siteSearch = $('.header-siteSearch');
			var flag = false;
			var scrollTopNow = void 0;

			if (SAISON.va.window.width < 1024) {
				// ハンバーガーメニュー
				$hamburger.on('click', function () {
					if (!flag) {
						$overlay.addClass(a);
						$siteSearch.removeClass(v);
						setTimeout(function () {
							$siteSearch.removeClass(a);
							$overlay.addClass(v);
						});
						$nav.addClass(a);
						$hamburger.addClass(a);
						fixedOnContainer();
						flag = true;
					} else {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
						}, 400);
						$nav.removeClass(a);
						$hamburger.removeClass(a);
						fixedOffContainer();
						flag = false;
					}
				});

				$overlay.on('click', function () {
					$overlay.removeClass(v);
					setTimeout(function () {
						$overlay.removeClass(a);
					}, 400);
					$nav.removeClass(a);
					$hamburger.removeClass(a);
					fixedOffContainer();
					flag = false;
				});
			}
			var fixedOnContainer = function fixedOnContainer() {
				scrollTopNow = $(window).scrollTop();
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
			};
			var fixedOffContainer = function fixedOffContainer() {
				$('.container').css({
					position: 'static'
				});
				$('body').removeClass(f);
				$(window).scrollTop(scrollTopNow);
			};
		},
		navCurrent: function navCurrent() {
			$('.header-nav-ul-li-a').each(function (idx, ele) {
				var thisHref = $(ele).attr('href');
				if (SAISON.va.pathname.indexOf(thisHref) !== -1) {
					$(ele).addClass(a);
				}
			});
		},
		globalNav: function globalNav() {
			if (SAISON.va.window.width > 1024) {
				var m = 'is-mouseon';
				var $menu = $('.js-header-menu');

				$menu.on('mouseover', function (e) {
					var $this = $(e.currentTarget);
					var $thisMenu = $this.next('.js-header-menuBlock');
					$('.js-header-menuBlock').not($thisMenu).removeClass(v);
					$thisMenu.addClass(v);
				});
				$('.header-nav-ul-li').on('mouseleave', function (e) {
					$('.js-header-menuBlock').removeClass(v);
					$('.js-header-menu').removeClass(m);
				});
				$('.js-header-menuBlock').on('mouseover', function (e) {
					$(e.currentTarget).prev('.js-header-menu').addClass(m);
				});

				// カレント
				$('.js-header-menu-link').each(function (idx, ele) {
					if ($(ele).attr('href') === SAISON.va.pathname || $(ele).attr('href') + 'index.html' === SAISON.va.pathname) {
						$(ele).addClass(a);
					}
				});
			}
		},
		sideNav: function sideNav() {
			if ($('.mod-sideNav-nav').length) {
				$('a.mod-sideNav-nav-ul-li-a').each(function (idx, ele) {
					var thisHref = $(ele).attr('href');
					if (thisHref === SAISON.va.pathname || thisHref + 'index.html' === SAISON.va.pathname) {
						$(ele).addClass(a);
					}

					// ご利用ガイド
					if ($(ele).attr('data-name')) {
						if ($('.container').hasClass($(ele).attr('data-name'))) {
							$(ele).addClass(a);
						}
					}
				});
				$('.__sub_item').find('.mod-sideNav-nav-ul-li-a.is-active').parents('.js-toggleBlock').slideDown();
				$('.__sub_item').find('.mod-sideNav-nav-ul-li-a.is-active').parents('.js-toggleBlock').prev('.js-toggle').addClass(a);
			}
		},
		siteSearch: function siteSearch() {
			var thisScroll = void 0;
			$('.header-search').on('click', function () {
				thisScroll = $(document).scrollTop();
				$('body').css({
					'position': 'fixed',
					'top': '-' + thisScroll + 'px'
				});
				$('.header-siteSearch').addClass(a);
				setTimeout(function () {
					$('.header-siteSearch').addClass(v);
				}, 100);
			});
			$('.header-siteSearch-overlay').on('click', function () {
				$('.header-siteSearch').removeClass(v);
				setTimeout(function () {
					$('.header-siteSearch').removeClass(a);
				}, 100);
				$('body').css({
					'position': 'relative',
					'top': 'auto'
				});
				$(document).scrollTop(thisScroll);
			});
		},
		tabChange: function tabChange() {
			if ($('.js-tabChange').length) {
				var $hash = location.hash;
				if ($hash.length) {
					$('.js-tabChange').each(function (idx, ele) {
						if ($(ele).attr('data-name') === $hash.replace('#', '')) {
							$(ele).addClass(a);
							$('.js-tab-content').eq(idx).addClass(a);
						}
					});
					if (!$('.js-tabChange [data-name="' + $hash.replace('#', '') + '"]').length) {
						$('.js-tab-content').eq(0).addClass(a);
						$('.js-tabChange').eq(0).addClass(a);
					}
				} else {
					$('.js-tab-content').eq(0).addClass(a);
					$('.js-tabChange').eq(0).addClass(a);
				}
				$('.js-tabChange').each(function (idx, val) {
					$(val).on('click', function () {
						$('.js-tabChange').removeClass(a);
						$(val).addClass(a);
						$('.js-tab-content').removeClass(a);
						$('.js-tab-content').eq(idx).addClass(a);
					});
				});

				// タブ以外でのタブ切り替え
				$('.js-tabChange-inpage').on('click', function (e) {
					var thisTab = $(e.currentTarget).attr('tab-name');
					$('.js-tabChange').removeClass(a);
					$('.js-tab-content').removeClass(a);
					$('.js-tabChange').each(function (idx, ele) {
						if ($(ele).attr('data-name') === thisTab) {
							$(ele).addClass(a);
						}
						$('.js-tab-content').eq(idx).addClass(a);
					});
					if ($(e.currentTarget).attr('href').slice(0, 1) === '#') {
						var _scrollToObject = function _scrollToObject(_self, _speed) {
							var hash = '#' + _self.split('#')[1];
							var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

							if (hash !== '#pagetop') {
								if (SAISON.va.window.width < SAISON.va.device.sp) {
									pos -= 60;
								} else {
									pos -= 120;
								}
							}

							$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
						};

						var speed = 1200;
						if (/#/.test(e.currentTarget.href)) {
							_scrollToObject(e.currentTarget.href, speed);
						}
						return false;
					}
				});
			}
		},
		chatBot: function chatBot() {
			window.onload = function () {

				if ($('#konnect-container').length) {
					var scrollStopEventTrigger = function scrollStopEventTrigger() {
						if (timer) {
							clearTimeout(timer);
						}
						timer = setTimeout(function () {
							$(window).trigger(scrollStopEvent);
						}, delay);
					};

					// スクロールの停止を検知する
					var scrollStopEvent = new $.Event('scrollstop');
					var delay = 3000;
					var timer = void 0;

					$(window).on('scroll', scrollStopEventTrigger);
					$('body').on('touchmove', scrollStopEventTrigger);

					// スクロール停止して3秒たったらチャットボット出現
					$(window).on('scroll', function () {
						$(window).on('scrollstop', function () {
							$('#konnect-container').addClass(a);
						});
					});
				}
			};
		},
		imgMatchHeight: function imgMatchHeight() {
			if ($('figure[data-mh="img"]').length) {
				$('figure[data-mh="img"]').matchHeight();
			}
			if ($('a[data-mh="pickup"]').length) {
				$('a[data-mh="pickup"]').matchHeight();
			}
		},
		setShareLinks: function setShareLinks() {
			if ($('.js-share').length) {
				// facebook
				var url = document.URL;
				var title = encodeURIComponent(document.title);
				$('.js-share-facebook').attr('data-href', url);
				$('.js-share-facebook').find('a.fb-xfbml-parse-ignore').attr('href').replace(/#link/ig, url);

				// LINE
				$('.js-share-line').attr('data-url', url);
			}
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.headerSwitch();
			_this.navCurrent();
			_this.sideNav();
			_this.siteSearch();
			_this.tabChange();
			_this.chatBot();
			_this.imgMatchHeight();
			_this.setShareLinks();
			_this.globalNav();

			svg4everybody();
		}
	};

	$(function () {
		return SAISON.localDecision() ? SAISON.localLoading() : SAISON.loadDelayScript();
	});
})(window.jQuery);